/** @file Minimal toast utility. */
import { h } from "./dom.js";

/** @type {HTMLElement | null} */
let host = null;

function ensureHost() {
  if (host) {
    return host;
  }
  host = h("div", { class: "hb-toast-host", role: "status", "aria-live": "polite" });
  document.body.appendChild(host);
  return host;
}

/**
 * @param {string} message
 * @param {{ duration?: number }} [opts]
 */
export function showToast(message, opts = {}) {
  const h_ = ensureHost();
  const t = h("div", { class: "hb-toast" }, [message]);
  h_.appendChild(t);
  setTimeout(() => {
    t.classList.add("hb-toast--out");
    setTimeout(() => t.remove(), 200);
  }, opts.duration ?? 3000);
}
